import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const PartnerLogoCarousel = () => {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/public/partner-logos").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])); }, []);
    const sequence = useMemo(() => {
        if (!items.length) return [];
        const repetitions = Math.max(1, Math.ceil(12 / items.length));
        return Array.from({ length: repetitions }, () => items).flat();
    }, [items]);
    if (!items.length) return null;
    const duration = Math.max(36, Math.min(72, sequence.length * 4.2));
    const logo = (item, key, accessible = true) => {
        const image = <img src={`${backendUrl}${item.image_url}`} alt={accessible ? `Logo ${item.name}` : ""} loading="lazy" decoding="async" className="partner-carousel-logo" />;
        return item.profile_url ? <a key={key} data-testid={accessible ? `partner-logo-link-${item.id}` : undefined} href={item.profile_url} tabIndex={accessible ? 0 : -1} aria-hidden={!accessible} aria-label={accessible ? `Apri il profilo di ${item.name}` : undefined} className="partner-logo-link">{image}</a> : <React.Fragment key={key}>{image}</React.Fragment>;
    };
    const group = (suffix, hidden = false) => <div className="partner-logo-group" aria-hidden={hidden}>{sequence.map((item, index) => logo(item, `${suffix}-${item.id}-${index}`, !hidden && index < items.length))}</div>;
    return (
        <section data-testid="partner-logo-carousel" aria-label="Agenzie partner" className="partner-logo-strip">
            <h2 data-testid="partner-logo-title" className="partner-logo-title">I nostri partner</h2>
            {items.length === 1 ? (
                <div data-testid="partner-logo-single" className="partner-logo-single">{logo(items[0], items[0].id, true)}</div>
            ) : (
                <div className="partner-logo-viewport"><div className="partner-logo-track" style={{ "--partner-carousel-duration": `${duration}s` }}>{group("first")}{group("second", true)}</div></div>
            )}
        </section>
    );
};